import BlockIrrigationSettings from 'components/mobile/settings/BlockIrrigationSettings';
import { SettingsPage } from '../settings';
import { withPlatformDetect } from '../../utils/withPlatformDetect';
import { Schedule } from '../mobile/schedule/Schedule';
import { ControlPage } from '../mobile/control/ControlPage';
import { BlockDetails } from '../mobile/control/ControlSummary/BlockDetails';
import { Home as HomeMobile } from '../mobile/home/Home';
import { CropDetailsPage } from '../mobile/home/CropDetailsPage';
import { RecommendationAction } from '../mobile/home/RecommendationAction';
import { RecommendationDetail } from '../mobile/home/RecommendationDetail';
import { ImageryAnomalyDetailPage } from '../mobile/home/ImageryAnomalyDetailPage';
import { SchedulingInvestigationPage } from '../mobile/home/SchedulingInvestigationPage';
import { Map as MapMobile } from '../mobile/map/Map';
import { ListPage } from '../mobile/list/ListPage';
import { ScheduleCalendar } from '../mobile/schedule/ScheduleCalendar';
import { ScheduleShare } from '../mobile/schedule/ScheduleShare';
import { ScheduleDetail } from '../mobile/schedule/ScheduleDetail';
import { ScheduleCreate } from '../mobile/schedule/ScheduleCreate';
import { ScheduleEdit as ScheduleEditMobile } from '../mobile/schedule/ScheduleEdit';
import { SoilSensorList } from '../mobile/list/SoilSensorList';
import { PlantSensorList } from '../mobile/list/PlantSensorList';
import { TemperatureHumiditySensorList } from '../mobile/list/TemperatureHumiditySensorList'; 
// import { PressureSensorsList as ControlPressureSensorList } from '../mobile/control/ControlValves/PressureSensorsList';
import { IRSensorList } from '../mobile/list/IRSensorList';
import { ValveSensorList } from '../mobile/list/ValveSensorList';
import { FlowSensorList } from '../mobile/list/FlowSensorList';
import { OrganizationPage } from '../organization';
import BulkConfigApplyPage from '../nodes/BulkConfigApplyPage';
import OTAUpdate from '../nodes/OTAUpdate';
import DeleteFirmwareVersion from '../nodes/DeleteFirmwareVersion';
import RuleSettingsPage from '../settings/components/RuleSettingsPage';
import GlobalSettingsPage from 'components/settings/components/GlobalSettingsPage';

import {
  ScheduleCreatePage,
  SchedulePage,
  ScheduleUpdatePage,
} from '../schedule';

import {
  IrrigationControlSummary,
} from '../control';

import {
  EventsPage,
} from '../stream';

import {
  Dashboard,
} from '../dashboard';

import Page404 from './Page404';
import Mobile404 from '../mobile/Mobile404';
import { PumpList } from '../mobile/list/PumpList';
import { WeatherList } from '../mobile/list/WeatherList';
import { PressureSensorList } from '../mobile/list/PressureSensorList';
import { Settings } from '../mobile/settings/Settings';
import { ROUTES as MOBILE_ROUTES } from '../settings/routes';
import { ROUTES as ORGANIZATION_ROUTES } from '../organization/routes';
import { isMobile } from '../../utils/detectDevice';
import { WaterUsageShare } from '../mobile/schedule/WaterUsageShare';
import RanchSelection from '../mobile/farmhand/RanchSelection';
import BlockSelection from '../mobile/farmhand/BlockSelection';
import BlockControl from '../mobile/farmhand/BlockControl';
import Documentation from '../mobile/components/Documentation';
import SensorDetailPage from '../mobile/list/SensorDetailPage';
import { MultiGraphPage } from '../graph';
import ZendeskArticle from '../mobile/components/ZendeskArticle';
import { GroundMissionDetailPage } from '../mobile/home/GroundMissionDetailPage';
import { GroundMissionActionPage } from '../mobile/home/GroundMissionActionPage';
import { Organization } from '../mobile/organization/Organization';
import NodeOperations from 'components/settings/components/NodeOperations';
import NodeAssociatedSensorsList from 'components/settings/components/NodeAssociatedSensorsList';
import EntityMonitoring from 'components/settings/components/EntityMonitoring';
import RanchIssuesList from 'components/settings/components/RanchIssuesList';
import InstallationCheck from 'components/settings/components/InstallationCheck';

export const ROUTE_KEYS = {
  ROOT: '/',
  CONTROL: '/control',
  RECOMMENDATION: '/recommendation',
  RECOMMENDATION_CROP_DETAILS: '/recommendation/block/crop-details',
  RECOMMENDATION_ACTION: '/recommendation/action/:blockId',
  ANOMALY_DETAIL: '/recommendation/anomaly/detail/:identifier',
  ANOMALY_DETAIL_INVESTIGATE: '/recommendation/anomaly/investigate/:blockId',
  GROUND_MISSION_DETAIL: '/recommendation/ground_mission/detail/:identifier',
  GROUND_MISSION_DETAIL_INVESTIGATE: '/recommendation/ground_mission/investigate/:blockId',
  GROUND_MISSION_ACTION: '/recommendation/ground_mission/action/:blockId',
  RECOMMENDATION_DETAIL: '/recommendation/detail/:identifier',
  SCHEDULE: '/schedule',
  SCHEDULE_CREATE: '/schedule/new',
  SCHEDULE_EDIT: '/schedule/edit',
  SCHEDULE_CALENDAR: '/schedule/calendar',
  SCHEDULE_DETAIL: '/schedule/detail/:blockId/:id',
  SCHEDULE_SHARE: '/schedule/share',
  WATERUSAGE_SHARE: '/schedule/waterusage/share',
  SETTINGS_PAGE: '/settings',
  MAP: '/map',
  EVENTS: '/events',
  DASHBOARD: '/dashboard',
  LIST: '/list',
  BLOCK_DETAILS: '/control/block/:id',
  CONTROL_PUMP_DETAILS: '/control/pump/:sensorType/:id/:blockId',
  CONTROL_PRESSURE_SENSORS_LIST: '/list/pressure-sensors/:id',
  CONTROL_VALVE_DETAILS: '/control/valve-sensor/:sensorType/:id',
  SOIL_SENSOR_LIST: '/list/soil-sensor',
  PLANT_SENSOR_LIST: '/list/plant-sensor',
  PRESSURE_SENSORS_LIST: '/list/pressure-sensor',
  IR_SENSORS_LIST: '/list/infrared-sensor',
  VALVE_SENSORS_LIST: '/list/valve-sensor',
  FLOW_SENSORS_LIST: '/list/flow-sensor',
  PUMP_LIST: '/list/pump',
  LIST_PUMP_DETAILS: '/list/pump/:sensorType/:id/:blockId',
  WEATHER_LIST: '/list/weather',
  HELP: '/help',
  FARMHAND_RANCHES: '/farmhand/ranches',
  FARMHAND_BLOCKS: '/farmhand/ranches/:id',
  FARMHAND_BLOCK_CONTROL: '/farmhand/ranches/:id/:blockId',
  DOCUMENTATION: '/help',
  ZENDESK_ARTICLE: '/help/article/:articleId',
  SENSOR_DETAIL: '/list/:listType/:sensorType/:id',
  GRAPH: '/graph',
  ORGANIZATION_PAGE: '/organization',
  APPLY_CONFIG_PAGE: '/update/apply-config',
  OTA_UPDATE: '/update/update-firmware',
  DELETE_FIRMWARE_VERSION: '/update/delete-firmware-version',
  RULE_SETTINGS: '/rule-settings',
  BLOCK_IRRIGATION_SETTINGS: '/blocks',
  TEMPERATURE_HUMIDITY_SENSORS_LIST: '/list/temperature-humidity',
  GLOBAL_SETTINGS: '/global-settings',
  ADMIN_OPERATIONS: '/admin-operations',
  INSTALLATION_CHECK: '/admin-operations/installation-check',
  ADMIN_OPERATIONS_SENSORS: '/admin-operations/associated-sensors',
  ENTITY_MONITORING: '/update/ranch-monitoring',
  RANCH_MONITORING_ISSUES: '/update/ranch-monitoring/issues',
};

const SHARED_ROUTES = {
  SETTINGS_PAGE: {
    component: withPlatformDetect(Settings, SettingsPage),
    exact: isMobile,
    key: ROUTE_KEYS.SETTINGS_PAGE,
    path: ROUTE_KEYS.SETTINGS_PAGE,
  },
  ORGANIZATION_PAGE: {
    component: withPlatformDetect(Organization, OrganizationPage),
    exact: isMobile,
    key: ROUTE_KEYS.ORGANIZATION_PAGE,
    path: ROUTE_KEYS.ORGANIZATION_PAGE,
  },
  RECOMMENDATION: {
    component: HomeMobile,
    exact: true,
    key: ROUTE_KEYS.RECOMMENDATION,
    path: ROUTE_KEYS.RECOMMENDATION,
  },
  RECOMMENDATION_CROP_DETAILS: {
    component: CropDetailsPage,
    exact: true,
    key: ROUTE_KEYS.RECOMMENDATION_CROP_DETAILS,
    path: ROUTE_KEYS.RECOMMENDATION_CROP_DETAILS,
  },
  RECOMMENDATION_ACTION: {
    component: RecommendationAction,
    exact: false,
    key: ROUTE_KEYS.RECOMMENDATION_ACTION,
    path: ROUTE_KEYS.RECOMMENDATION_ACTION,
  },
  RECOMMENDATION_DETAIL: {
    component: RecommendationDetail,
    exact: false,
    key: ROUTE_KEYS.RECOMMENDATION_DETAIL,
    path: ROUTE_KEYS.RECOMMENDATION_DETAIL,
  },
  ANOMALY_DETAIL: {
    component: ImageryAnomalyDetailPage,
    exact: false,
    key: ROUTE_KEYS.ANOMALY_DETAIL,
    path: ROUTE_KEYS.ANOMALY_DETAIL,
  },
  ANOMALY_DETAIL_INVESTIGATE: {
    component: SchedulingInvestigationPage,
    exact: false,
    key: ROUTE_KEYS.ANOMALY_DETAIL_INVESTIGATE,
    path: ROUTE_KEYS.ANOMALY_DETAIL_INVESTIGATE,
  },
  GROUND_MISSION_DETAIL: {
    component: GroundMissionDetailPage,
    exact: false,
    key: ROUTE_KEYS.GROUND_MISSION_DETAIL,
    path: ROUTE_KEYS.GROUND_MISSION_DETAIL,
  },
  GROUND_MISSION_DETAIL_INVESTIGATE: {
    component: SchedulingInvestigationPage,
    exact: false,
    key: ROUTE_KEYS.GROUND_MISSION_DETAIL_INVESTIGATE,
    path: ROUTE_KEYS.GROUND_MISSION_DETAIL_INVESTIGATE,
  },
  GROUND_MISSION_ACTION: {
    component: GroundMissionActionPage,
    exact: false,
    key: ROUTE_KEYS.GROUND_MISSION_ACTION,
    path: ROUTE_KEYS.GROUND_MISSION_ACTION,
  },
  SCHEDULE: {
    component: withPlatformDetect(Schedule, SchedulePage),
    exact: true,
    key: ROUTE_KEYS.SCHEDULE,
    path: ROUTE_KEYS.SCHEDULE,
  },
  SCHEDULE_CREATE: {
    component: withPlatformDetect(ScheduleCreate, ScheduleCreatePage),
    exact: true,
    key: ROUTE_KEYS.SCHEDULE_CREATE,
    path: ROUTE_KEYS.SCHEDULE_CREATE,
  },
  SCHEDULE_EDIT: {
    component: withPlatformDetect(ScheduleEditMobile, ScheduleUpdatePage),
    exact: true,
    key: ROUTE_KEYS.SCHEDULE_EDIT,
    path: ROUTE_KEYS.SCHEDULE_EDIT,
  },
  SCHEDULE_CALENDAR: {
    component: withPlatformDetect(ScheduleCalendar, Page404),
    exact: true,
    key: ROUTE_KEYS.SCHEDULE_CALENDAR,
    path: ROUTE_KEYS.SCHEDULE_CALENDAR,
  },
  SCHEDULE_DETAIL: {
    component: withPlatformDetect(ScheduleDetail, Page404),
    exact: false,
    key: ROUTE_KEYS.SCHEDULE_DETAIL,
    path: ROUTE_KEYS.SCHEDULE_DETAIL,
  },
  SCHEDULE_SHARE: {
    component: withPlatformDetect(ScheduleShare, Page404),
    exact: true,
    key: ROUTE_KEYS.SCHEDULE_SHARE,
    path: ROUTE_KEYS.SCHEDULE_SHARE,
  },
  CONTROL: {
    component: withPlatformDetect(ControlPage, IrrigationControlSummary),
    exact: true,
    key: ROUTE_KEYS.CONTROL,
    path: ROUTE_KEYS.CONTROL,
  },
  MAP: {
    component: withPlatformDetect(MapMobile, MapMobile),
    exact: true,
    key: ROUTE_KEYS.MAP,
    path: ROUTE_KEYS.MAP,
  },
  EVENTS: {
    component: withPlatformDetect(EventsPage, EventsPage),
    exact: true,
    key: ROUTE_KEYS.EVENTS,
    path: ROUTE_KEYS.EVENTS,
  },
  DASHBOARD: {
    component: withPlatformDetect(Mobile404, Dashboard),
    exact: true,
    key: ROUTE_KEYS.DASHBOARD,
    path: ROUTE_KEYS.DASHBOARD,
  },
  LIST: {
    component: ListPage,
    exact: true,
    key: ROUTE_KEYS.LIST,
    path: ROUTE_KEYS.LIST,
  },
  BLOCK_DETAILS: {
    component: withPlatformDetect(BlockDetails, Page404),
    exact: true,
    key: ROUTE_KEYS.BLOCK_DETAILS,
    path: ROUTE_KEYS.BLOCK_DETAILS,
  },
  CONTROL_PUMP_DETAILS: {
    component: withPlatformDetect(SensorDetailPage, Page404),
    exact: true,
    key: ROUTE_KEYS.CONTROL_PUMP_DETAILS,
    path: ROUTE_KEYS.CONTROL_PUMP_DETAILS,
  },
  SOIL_SENSOR_LIST: {
    component: SoilSensorList,
    exact: true,
    key: ROUTE_KEYS.SOIL_SENSOR_LIST,
    path: ROUTE_KEYS.SOIL_SENSOR_LIST,
  },
  PLANT_SENSOR_LIST: {
    component: PlantSensorList,
    exact: true,
    key: ROUTE_KEYS.PLANT_SENSOR_LIST,
    path: ROUTE_KEYS.PLANT_SENSOR_LIST,
  },
  PUMP_LIST: {
    component: PumpList,
    exact: true,
    key: ROUTE_KEYS.PUMP_LIST,
    path: ROUTE_KEYS.PUMP_LIST,
  },
  LIST_PUMP_DETAILS: {
    component: SensorDetailPage,
    exact: true,
    key: ROUTE_KEYS.LIST_PUMP_DETAILS,
    path: ROUTE_KEYS.LIST_PUMP_DETAILS,
  },
  WEATHER_LIST: {
    component: WeatherList,
    exact: true,
    key: ROUTE_KEYS.WEATHER_LIST,
    path: ROUTE_KEYS.WEATHER_LIST,
  },
  CONTROL_PRESSURE_SENSORS_LIST: {
    component: PressureSensorList,
    exact: true,
    key: ROUTE_KEYS.CONTROL_PRESSURE_SENSORS_LIST,
    path: ROUTE_KEYS.CONTROL_PRESSURE_SENSORS_LIST,
  },
  PRESSURE_SENSORS_LIST: {
    component: PressureSensorList,
    exact: true,
    key: ROUTE_KEYS.PRESSURE_SENSORS_LIST,
    path: ROUTE_KEYS.PRESSURE_SENSORS_LIST,
  },
  CONTROL_VALVE_DETAILS: {
    component: SensorDetailPage,
    exact: true,
    key: ROUTE_KEYS.CONTROL_VALVE_DETAILS,
    path: ROUTE_KEYS.CONTROL_VALVE_DETAILS,
  },
  IR_SENSORS_LIST: {
    component: IRSensorList,
    exact: true,
    key: ROUTE_KEYS.IR_SENSORS_LIST,
    path: ROUTE_KEYS.IR_SENSORS_LIST,
  },
  VALVE_SENSORS_LIST: {
    component: ValveSensorList,
    exact: true,
    key: ROUTE_KEYS.VALVE_SENSORS_LIST,
    path: ROUTE_KEYS.VALVE_SENSORS_LIST,
  },
  FLOW_SENSORS_LIST: {
    component: FlowSensorList,
    exact: true,
    key: ROUTE_KEYS.FLOW_SENSORS_LIST,
    path: ROUTE_KEYS.FLOW_SENSORS_LIST,
  },
  WATERUSAGE_SHARE: {
    component: withPlatformDetect(WaterUsageShare, Page404),
    exact: true,
    key: ROUTE_KEYS.WATERUSAGE_SHARE,
    path: ROUTE_KEYS.WATERUSAGE_SHARE,
  },
  DOCUMENTATION: {
    component: withPlatformDetect(Documentation, Documentation),
    exact: true,
    key: ROUTE_KEYS.DOCUMENTATION,
    path: ROUTE_KEYS.DOCUMENTATION,
  },
  ZENDESK_ARTICLE: {
    component: ZendeskArticle,
    exact: true,
    key: ROUTE_KEYS.ZENDESK_ARTICLE,
    path: ROUTE_KEYS.ZENDESK_ARTICLE,
  },
  SENSOR_DETAIL: {
    component: SensorDetailPage,
    exact: true,
    key: ROUTE_KEYS.SENSOR_DETAIL,
    path: ROUTE_KEYS.SENSOR_DETAIL,
  },
  GRAPH: {
    component: MultiGraphPage,
    exact: true,
    key: ROUTE_KEYS.GRAPH,
    path: ROUTE_KEYS.GRAPH,
  },
  APPLY_CONFIG_PAGE: {
    component: BulkConfigApplyPage,
    exact: isMobile,
    key: ROUTE_KEYS.APPLY_CONFIG_PAGE,
    path: ROUTE_KEYS.APPLY_CONFIG_PAGE,
  },
  OTA_UPDATE: {
    component: OTAUpdate,
    exact: isMobile,
    key: ROUTE_KEYS.OTA_UPDATE,
    path: ROUTE_KEYS.OTA_UPDATE,
  },
  DELETE_FIRMWARE_VERSION: {
    component: DeleteFirmwareVersion,
    exact: isMobile,
    key: ROUTE_KEYS.DELETE_FIRMWARE_VERSION,
    path: ROUTE_KEYS.DELETE_FIRMWARE_VERSION,
  },
  RULE_SETTINGS: {
    component: RuleSettingsPage,
    exact: true,
    key: ROUTE_KEYS.RULE_SETTINGS,
    path: ROUTE_KEYS.RULE_SETTINGS,
  },
  BLOCK_IRRIGATION_SETTINGS: {
    component: BlockIrrigationSettings,
    exact: true,
    key: ROUTE_KEYS.BLOCK_IRRIGATION_SETTINGS,
    path: ROUTE_KEYS.BLOCK_IRRIGATION_SETTINGS,
  },
  TEMPERATURE_HUMIDITY_SENSORS_LIST: {
    component: TemperatureHumiditySensorList,
    exact: true,
    key: ROUTE_KEYS.TEMPERATURE_HUMIDITY_SENSORS_LIST,
    path: ROUTE_KEYS.TEMPERATURE_HUMIDITY_SENSORS_LIST,
  },
  GLOBAL_SETTINGS: {
    component: GlobalSettingsPage,
    exact: true,
    key: ROUTE_KEYS.GLOBAL_SETTINGS,
    path: ROUTE_KEYS.GLOBAL_SETTINGS,
  },
  INSTALLATION_CHECK: {
    component: InstallationCheck,
    exact: true,
    key: ROUTE_KEYS.INSTALLATION_CHECK,
    path: ROUTE_KEYS.INSTALLATION_CHECK,
  },
  ADMIN_OPERATIONS: {
    component: NodeOperations,
    exact: true,
    key: ROUTE_KEYS.ADMIN_OPERATIONS,
    path: ROUTE_KEYS.ADMIN_OPERATIONS,
  },
  ADMIN_OPERATIONS_SENSORS: {
    component: NodeAssociatedSensorsList,
    exact: true,
    key: ROUTE_KEYS.ADMIN_OPERATIONS_SENSORS,
    path: ROUTE_KEYS.ADMIN_OPERATIONS_SENSORS,
  },
  ENTITY_MONITORING: {
    component: EntityMonitoring,
    exact: true,
    key: ROUTE_KEYS.ENTITY_MONITORING,
    path: ROUTE_KEYS.ENTITY_MONITORING,
  },
  RANCH_MONITORING_ISSUES: {
    component: RanchIssuesList,
    exact: true,
    key: ROUTE_KEYS.RANCH_MONITORING_ISSUES,
    path: ROUTE_KEYS.RANCH_MONITORING_ISSUES,
  },
};

const MOBILE_SETTINGS_ROUTES = {
  ACCOUNT: MOBILE_ROUTES.ACCOUNT,
  NOTIFICATION: MOBILE_ROUTES.NOTIFICATION,
  UNITS: MOBILE_ROUTES.UNITS,
  LANGUAGE: MOBILE_ROUTES.LANGUAGE,
  SENSORS: MOBILE_ROUTES.SENSORS,
  IRRIGATION_SETTINGS: MOBILE_ROUTES.IRRIGATION_SETTINGS,
};

const MOBILE_ORGANIZATION_ROUTES = {
  TEAMS_LIST: ORGANIZATION_ROUTES.TEAMS_LIST,
  USERS_LIST: ORGANIZATION_ROUTES.USERS_LIST,
  CREATE_TEAM: ORGANIZATION_ROUTES.CREATE_TEAM,
  TEAM_DETAILS: ORGANIZATION_ROUTES.TEAM_DETAILS,
  INVITE_USER: ORGANIZATION_ROUTES.INVITE_USER,
  INVITE_USER_NO_TEAM: ORGANIZATION_ROUTES.INVITE_USER_NO_TEAM,
  USER_DETAILS: ORGANIZATION_ROUTES.USER_DETAILS,
};

export const FARMHAND_ROUTES = {
  FARMHAND_RANCHES: {
    component: withPlatformDetect(RanchSelection, Page404),
    exact: true,
    key: ROUTE_KEYS.FARMHAND_RANCHES,
    path: ROUTE_KEYS.FARMHAND_RANCHES,
  },
  FARMHAND_BLOCKS: {
    component: withPlatformDetect(BlockSelection, Page404),
    exact: true,
    key: ROUTE_KEYS.FARMHAND_BLOCKS,
    path: ROUTE_KEYS.FARMHAND_BLOCKS,
  },
  FARMHAND_BLOCK_CONTROL: {
    component: withPlatformDetect(BlockControl, Page404),
    exact: true,
    key: ROUTE_KEYS.FARMHAND_BLOCK_CONTROL,
    path: ROUTE_KEYS.FARMHAND_BLOCK_CONTROL,
  },
};

export const ROUTES = {
  ...SHARED_ROUTES,
  ...MOBILE_SETTINGS_ROUTES,
  ...MOBILE_ORGANIZATION_ROUTES,
};
